
const driverReport= {
  driverReportTitle: 'Fahrerbericht',
  id: 'Ausweis',
  driver: 'Fahrer',
  filter: {
    driver: 'Fahrer',
    car: 'Fahrzeug',
    submit: 'Filter',
    export: 'Exportieren',
    clear: 'Filter löschen',
    validation: {
      startDateRequired: 'Startdatum ist erforderlich',
      endDateRequired: 'Enddatum ist erforderlich',
    },
  },

  table: {
    drivers: 'Fahrer',
    vehicles: 'Fahrzeuge',
    trips: 'Fahrten',
  },

  vechile: 'Fahrzeug',
  pax: 'Personen',
  cash: 'Barzahlung',
  start: 'Starten',
  end: 'Ende',
  reservations: {
    reservations: 'Reservierungen',
    table: {
      from: 'Von',
      to: 'Bis',
      date: 'Datum',
      passenger: 'Fahrgast',
      reservation: 'Reservierungs-ID',
      paymentType: 'Bezahlarten',
      pax: 'Personen',
      pickup: 'Abholen',
      drop_off: 'absetzen',
      duration: 'Dauer',
      car: 'Auto',
    },
  },

  form: {
    dateEnd: 'Datum Ende',
    dateStart: 'Datum Beginn',
  },
};


export default driverReport;